import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./axiosBaseQuery";
import { AuthInfo } from "../../objects/authInfo";

export const commonApi = createApi({
    reducerPath: 'api.common',
    baseQuery: axiosBaseQuery({
        baseUrl: (queryParameters) => {
            if (queryParameters.v2) {
                return `${API_HREF}client/${window.id_owner}`.replace('v1', 'v2');
            }
            return `${API_HREF}client/${window.id_owner}`;
        }
    }),
    tagTypes: [
        'auth-info',
        'check-permission'
    ],
    endpoints: (builder) => ({
        getAuthInfo: builder.query<
            AuthInfo | null,
            void
        >({
            query: (options) => {
                return {
                    url: `/auth/info/`,
                }
            },
            providesTags: ['auth-info']
        }),
        checkPermission: builder.query<
            { has_permission: boolean },
            {
                userId: number,
                target: string
            }
        >({
            query: (options) => {
                return {
                    url: `/user/${options.userId}/check_permission/`,
                    params: {
                        target: options.target
                    }
                }
            },
            providesTags: ['check-permission']
        }),
    })
});

export const {
    useGetAuthInfoQuery,
    useCheckPermissionQuery,
    useLazyCheckPermissionQuery
} = commonApi;